import React from "react";
import { SITE_DATA } from "../mock";
import DiscordIcon from "./icons/DiscordIcon";
import TikTokIcon from "./icons/TikTokIcon";

export default function Header() {
  const { brand, socials } = SITE_DATA;

  return (
    <header className="w-full px-4 sm:px-6 py-4 relative z-20">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        {/* Brand */}
        <a href="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-xl overflow-hidden border border-border/60 bg-secondary/40 shrink-0">
            <img
              src={brand.iconUrl}
              alt={brand.name}
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
          <div className="leading-tight">
            <div className="text-foreground font-semibold text-base sm:text-lg tracking-tight">
              {brand.name}
            </div>
            <div className="text-muted-foreground text-xs sm:text-sm">
              {brand.tagline}
            </div>
          </div>
        </a>

        {/* Social buttons */}
        <div className="flex items-center gap-2">
          <a
            href={socials.discord}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Discord"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:scale-[1.03] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            style={{
              backgroundColor: "#5865F2",
              boxShadow:
                "0 0 0 1px rgba(255,255,255,0.06) inset, 0 6px 18px -4px rgba(88,101,242,0.55), 0 2px 6px rgba(0,0,0,0.35)",
            }}
          >
            <DiscordIcon className="w-[18px] h-[18px] shrink-0" />
            <span className="leading-none">Discord</span>
          </a>
          <a
            href={socials.tiktok}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            className="inline-flex items-center gap-2 h-10 px-4 rounded-full text-sm font-semibold bg-white text-black transition-all duration-200 hover:scale-[1.03] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
            style={{
              boxShadow:
                "0 0 0 1px rgba(0,0,0,0.06) inset, 0 6px 18px -4px rgba(255,255,255,0.18), 0 2px 6px rgba(0,0,0,0.35)",
            }}
          >
            <TikTokIcon className="w-[18px] h-[18px] shrink-0" />
            <span className="leading-none">TikTok</span>
          </a>
        </div>
      </div>
    </header>
  );
}
